<div class="row main">
    <div class="col-sm-6">

      <nb-card size="large">
        <nb-card-header>
           <div class="row">
              <div class="col-12"><h4> Registro de actividad</h4></div>
           </div>
            <div class="row record-filter">
              <div class="col-2">
                <button nbButton shape="round" fullWidth="true" (click)="resetFilter()">Todos</button>
              </div>
              <div class="col-6">
                <nb-select multiple placeholder="Seleccione parcela" shape="round" fullWidth="true"
                [(ngModel)]="selectedParcela" (selectedChange)="updateRecordsFilter($event)"
                 >

                  <nb-option *ngFor="let parcela of parcelas" value="{{parcela.id}}">{{parcela.alias}}</nb-option>

                </nb-select>
              </div>

              <div class="col-4">
                <nb-select multiple placeholder="Seleccione tipo de registro" shape="round" fullWidth="true"
                [(ngModel)]="selectedRecordType" (selectedChange)="updateRecordsFilter($event)">

                  <nb-option *ngFor="let recType of recordTypes" value="{{recType.identifier}}">{{recType.name}}</nb-option>

                </nb-select>
              </div>

            </div>
            <div class="row record-filter" style="margin-top: 8px;" *ngIf="visorFirebaseService.userData && visorFirebaseService.userData.groupUserAdministrator">

              <div class="col-2">
                <div>&nbsp;</div>
              </div>
              <div class="col-6" >
                <nb-select multiple placeholder="Propietario" shape="round" fullWidth="true"
                [(ngModel)]="selectedPropietario" (selectedChange)="updateRecordsFilter($event)">

                  <nb-option *ngFor="let propietario of vGroupUsers" value="{{propietario.id}}">{{propietario.email}}</nb-option>

                </nb-select>
              </div>

            </div>
        </nb-card-header>
        <nb-card-body>

          <nb-list nbInfiniteList [threshold]="3" (bottomThreshold)="loadNextRegistros()">
            <nb-list-item *ngFor="let item of diario" class="registro-item"  >
                <ngx-registro-item2 [registro]="item" [vUser]="vUser" [vGroupUsers]="vGroupUsers" (click)="editarRegistro(item)"></ngx-registro-item2>
            </nb-list-item>
          </nb-list>


        </nb-card-body>

      </nb-card>
    </div>

    <div class="col-sm-6">
      <ngx-registro-editor *ngIf="selectedRegistro" [registro]="selectedRegistro" [vUser]="vUser" [vGroupUsers]="vGroupUsers" (onCloseEditor)="selectedRegistro = null;"
      (onDeleteItem)="deleteRegistro($event)" (onUpdateItem)="updateRegistro($event)"></ngx-registro-editor>

    </div>
</div>

<ng-template #deleteconfirmation let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Eliminar Registro Diario</nb-card-header>
    <nb-card-body>¿Realmente desea eliminar esta registro del diario de actividad de la parcela?


    </nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col-md-6">
          <button nbButton status="primary" (click)="ref.close()">Cancelar</button>
        </div>
        <div class="col-md-6 text-right">
          <button nbButton status="danger" (click)="confirmarEliminar(data.evento);ref.close()">Eliminar</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
